/**
 * Normalizes a list API response into a consistent paged shape.
 * Supports PagedResponse objects and legacy plain arrays.
 */
export function parsePagedResponse(data) {
  if (Array.isArray(data)) {
    const total = data.length;
    return {
      items: data,
      page: 0,
      size: total,
      totalElements: total,
      totalPages: total > 0 ? 1 : 0,
      hasNext: false,
      hasPrevious: false,
    };
  }

  if (data && Array.isArray(data.items)) {
    return {
      items: data.items,
      page: data.page ?? 0,
      size: data.size ?? data.items.length,
      totalElements: data.totalElements ?? data.items.length,
      totalPages: data.totalPages ?? 1,
      hasNext: Boolean(data.hasNext),
      hasPrevious: Boolean(data.hasPrevious),
    };
  }

  return {
    items: [],
    page: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
  };
}
